import React, { Component, useState, useEffect, useContext } from "react";
import { connect } from "react-redux";
import {
  Imóvel,
  Corretor,
  Caracteristica,
  Empresa,
  Cliente
} from "smart-imob-types";
import EmpresaContext, { EnviarContato } from "../../context";
import YouTube from "react-youtube";
import Loadable from "react-loadable";
import Slider from "react-slick";

import AgenciadorInfo from "./AgenciadorInfo";
import ImovelBasicInfo from "./ImovelBasicInfo";
import ImovelDetalhes from "./ImovelDetalhes";
import Loading from "../global-components/Loading";
import styled, { css } from "styled-components";
import { isIOS, isMobile, toBRL } from "../../utils/util_functions";
import PropertyForm from "./property-form";

const CaracBox = Loadable({
  loader: () => import(/* webpackChunkName: "carac-box" */ "./carac-box"),
  loading: Loading,
  modules: ["carac-box"]
});

const BtnBack = styled.div`
  .btn-back {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 20px;
    &:hover {
      filter: brightness(0);
    }
  }
`;

const SliderStyle = styled.div`
  .slick-prev,
  .slick-next {
    display: block;
    font-size: 28px;
    top: auto;
    left: auto;
    bottom: -15px;
    height: 40px;
    width: 40px;
    background: #fff;
    border: 1px solid #7070702b;
    text-align: center;
    line-height: 40px;
    border-radius: 50%;
    z-index: 1;
  }
  .slick-prev {
    right: 90px;
  }
  .slick-next {
    right: 25px;
    padding-left: 4px;
  }
  @media screen and (min-width: 560px) {
    .slick-prev,
    .slick-next {
      height: 50px;
      width: 50px;
      bottom: 25px;
      line-height: 46px;
    }
  }
`;

const NextArrow = props => {
  let context = useContext(EmpresaContext);
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      onClick={onClick}
      style={{ color: context.palleta.cor_primaria || "" }}
    >
      <i className="fa fa-angle-right" />
    </div>
  );
};

const PrevArrow = props => {
  let context = useContext(EmpresaContext);
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      onClick={onClick}
      style={{ color: context.palleta.cor_primaria || "" }}
    >
      <i className="fa fa-angle-left" />
    </div>
  );
};

type PropertyDetailsProps = {
  imovel: Imóvel;
};
type PropertyDetailsState = {
  uid: string | null;
  logoData: null | HTMLImageElement;
  url_fotos: boolean;
};
class PropertyDetails extends Component<
  PropertyDetailsProps,
  PropertyDetailsState
> {
  state = {
    uid: sessionStorage.getItem("uid") || localStorage.getItem("uid") || null,
    logoData: null,
    url_fotos: false
  };
  context!: Empresa;
  firstInputRef = React.createRef<HTMLInputElement>();
  async componentDidMount() {
    let { imovel } = this.props;
    // console.log("imovel", imovel);
    window["imovel"] = imovel;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.setState({
      url_fotos: urlParams.has("VerFotos")
    });
    await fetch(
      "https://us-central1-smartimob-dev-test.cloudfunctions.net/RegistrarVisualizacao",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          imovel_id: imovel.db_id,
          empresa: this.context.db_id
        })
      }
    );
  }
  render() {
    let { imovel } = this.props;
    const { codigo, fotos } = imovel;
    // console.log('empresa', this.context)
    let caracteristicas = imovel.caracteristicas
      ? imovel.caracteristicas
          .sort((a, b) => (a.nome || "").localeCompare(b.nome || ""))
          .filter(carac => carac.value === true)
      : [];
    let settings = {
      infinite: true,
      // lazyLoad: true,
      adaptiveHeight: true,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />
    };
    let videoID;
    if (imovel.video_youtube) {
      if (imovel.video_youtube.includes("v=")) {
        videoID = imovel.video_youtube.split("v=")[1];
      } else {
        videoID = imovel.video_youtube.replace("https://", "").split("/")[1];
      }
    }
    return (
      <div className="property-details-area">
        <div className="bg-gray pd-top-100 pd-bottom-90">
          <div className="container">
            <div className="row">
              <div
                className={
                  this.context.info_gen &&
                  !this.context.info_gen.ocultar_cadastro
                    ? "col-xl-9 col-lg-8"
                    : "col-xl-12"
                }
              >
                <div className="property-details-slider-alt">
                  <SliderStyle>
                    <Slider {...settings}>
                      {imovel.video_youtube && (
                        <div className="item">
                          <div
                            className="thumb"
                            style={{
                              height:
                                window.screen.width > 800 ? "90vh" : "auto",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              position: "relative"
                            }}
                          >
                            <div
                              style={{
                                background:
                                  this.context.imovel_use_bg === false
                                    ? `#f6f7fb`
                                    : `url('https://i.ytimg.com/vi/${videoID}/sddefault.jpg')`,
                                filter: "blur(4px)",
                                position: "absolute",
                                left: 0,
                                top: 0,
                                width: "100%",
                                height: "100%",
                                backgroundSize: "cover",
                                zIndex: -1
                              }}
                            />
                            <YouTube videoId={videoID} />
                          </div>
                        </div>
                      )}
                      {fotos
                        .sort(
                          (a, b) =>
                            a.destaque
                              ? -1
                              : parseInt(String(a.ordem)) -
                                parseInt(String(b.ordem))
                        )
                        .slice(
                          0,
                          this.state.url_fotos
                            ? Infinity
                            : !!this.state.uid ||
                              (imovel.bloqueio_fotos === undefined ||
                                imovel.bloqueio_fotos === false)
                              ? Infinity
                              : this.context.bloqueio_fotos_quantidade || 3
                        )
                        .map((foto, i) => (
                          <SliderItem
                            logo={
                              (this.context.marca_da_agua &&
                                this.context.marca_da_agua.url) ||
                              this.context.logo
                            }
                            ocultar={this.context.ocultar_marca_agua}
                            marca_da_agua={this.context.marca_da_agua}
                            posicao={
                              this.context.marca_da_agua
                                ? this.context.marca_da_agua.posicao
                                : "null"
                            }
                            use_bg={this.context.imovel_use_bg}
                            key={`${codigo}_${i}`}
                            url={
                              foto.source ? foto.source.uri : foto.resized || ""
                            }
                            url_webp={
                              foto.source
                                ? foto.source.uri_webp
                                : foto.resized_webp || ""
                            }
                            alt={`Imóvel #${codigo}, foto ${i + 1}`}
                          />
                        ))}
                      {!this.state.url_fotos
                        ? !this.state.uid &&
                          (this.context.bloqueio_de_fotos === undefined ||
                            this.context.bloqueio_de_fotos === true)
                          ? (imovel.bloqueio_fotos === undefined ||
                              imovel.bloqueio_fotos === true) && (
                              <SliderItemWrap>
                                <div className="contact-form-wrap contact-form-bg">
                                  <h4>Registre-se para acessar + fotos!</h4>
                                  <h6>
                                    Preencha só alguns campos e receba acesso
                                    completo ao site!
                                  </h6>
                                  <PropertyForm
                                    firstInputRef={this.firstInputRef}
                                    agenciador_id={imovel.agenciador_id}
                                    uid={this.state.uid}
                                    codigo={this.props.imovel.codigo}
                                    db_id={this.props.imovel.db_id}
                                    temporada={this.props.imovel.temporada}
                                  />
                                  {/* <div className="btn-wrap">
                                  <button
                                    className="btn btn-yellow"
                                    onClick={() =>
                                      this.firstInputRef.current &&
                                      this.firstInputRef.current.focus()
                                    }
                                  >
                                    Acessar!
                                  </button>
                                </div> */}
                                </div>
                              </SliderItemWrap>
                            )
                          : null
                        : null}
                    </Slider>
                  </SliderStyle>
                </div>
                <div className="property-details-slider-info">
                  <h3>
                    {imovel.titulo || `Imóvel #${imovel.codigo}`}
                    <br />
                    {imovel.venda && !!imovel.preço_venda ? (
                      imovel.venda_exibir_valor_no_site === false ? (
                        <span>Valor sob consulta</span>
                      ) : !!imovel.preço_venda_desconto ? (
                        <>
                          <span style={{ textDecoration: "line-through" }}>
                            A venda de:{" "}
                            {toBRL(Number(imovel.preço_venda), imovel.moeda)}
                          </span>
                          <span>
                            {/* A venda por:{" "} */}
                            {this.context["sell_txt"] || "A partir de: "}
                            {toBRL(
                              Number(imovel.preço_venda_desconto),
                              imovel.moeda
                            )}
                          </span>
                        </>
                      ) : (
                        <span>
                          {/* A venda por:{" "} */}
                          {this.context["sell_txt"] || "A partir de: "}
                          {toBRL(Number(imovel.preço_venda), imovel.moeda)}
                        </span>
                      )
                    ) : null}
                    {imovel.venda && imovel.locação && <br />}
                    {imovel.locação && !!imovel.preço_locação ? (
                      imovel.locação_exibir_valor_no_site === false ? (
                        <span>Locação sob consulta</span>
                      ) : !!imovel.preço_locação_desconto &&
                      imovel.preço_locação_desconto > 0 ? (
                        <>
                          <span style={{ textDecoration: "line-through" }}>
                            A locação de:{" "}
                            {toBRL(Number(imovel.preço_locação), imovel.moeda)}
                          </span>
                          <span>
                            A locação por:{" "}
                            {toBRL(
                              Number(imovel.preço_locação_desconto),
                              imovel.moeda
                            )}
                          </span>
                        </>
                      ) : (
                        <span>
                          A locação por:{" "}
                          {toBRL(Number(imovel.preço_locação), imovel.moeda)}
                          /mês
                        </span>
                      )
                    ) : null}
                  </h3>
                  <div className="container-extra-prices">
                    {!!Number(imovel.IPTU) && (
                      <h5>IPTU: {toBRL(Number(imovel.IPTU))}</h5>
                    )}
                    {!!Number(imovel.preço_condominio) && (
                      <h5>
                        Condominio: {toBRL(Number(imovel.preço_condominio))}
                      </h5>
                    )}
                  </div>
                </div>
              </div>
              {this.context.info_gen &&
                !(this.context["inverter_cadastro_mobile"] && isMobile()) &&
                !this.context.info_gen.ocultar_cadastro && (
                  <div className="col-xl-3 col-lg-4">
                    <AgenciadorInfo
                      firstInputRef={this.firstInputRef}
                      agenciador_id={imovel.agenciador_id}
                      uid={this.state.uid}
                      codigo={this.props.imovel.codigo}
                      db_id={this.props.imovel.db_id}
                      temporada={this.props.imovel.temporada}
                    />
                  </div>
                )}
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row pd-top-90">
            <div className="col-lg-9">
              <ImovelBasicInfo imovel={imovel} />
              <div className="property-news-single-card style-two border-bottom-yellow">
                <h4>Descrição</h4>
                <p>{imovel.descrição}</p>
                <br />
                <p>{this.context.desc_imovel_text}</p>
              </div>
              {(imovel.mostrar_permuta_no_site ||
                imovel.mostrar_permuta_no_site === undefined) &&
                imovel.permuta_desc && (
                  <div className="property-news-single-card style-two border-bottom-yellow">
                    <h4>Permuta</h4>
                    <p>{imovel.permuta_desc}</p>
                  </div>
                )}
              {caracteristicas &&
                caracteristicas.length > 0 && (
                  <CaracBox caracteristicas={caracteristicas} />
                )}
              <ImovelDetalhes imovel={imovel} />
              {this.context["inverter_cadastro_mobile"] &&
                isMobile() && (
                  <div
                    className="col-xl-3 col-lg-4"
                    style={{ marginBottom: "50px" }}
                  >
                    <AgenciadorInfo
                      firstInputRef={this.firstInputRef}
                      agenciador_id={imovel.agenciador_id}
                      uid={this.state.uid}
                      codigo={this.props.imovel.codigo}
                      db_id={this.props.imovel.db_id}
                      temporada={this.props.imovel.temporada}
                    />
                  </div>
                )}
              {imovel.link_tour_virtual && (
                <div className="property-news-single-card border-bottom-yellow pb-3">
                  <div className="property-news-single-card mb-0">
                    <h4>Tour Virtual</h4>
                    <div className="thumb">
                      <div className="tour-link-container">
                        <a
                          href={imovel.link_tour_virtual}
                          target="_blank"
                          className="btn btn-yellow"
                        >
                          Ver o Tour
                        </a>
                        <span
                          style={{
                            background: `url(https://firebasestorage.googleapis.com/v0/b/smartimob-dev-test.appspot.com/o/Padr%C3%A3o%2F0002%20escurecido.jpg?alt=media&token=57a2bde4-930e-4d85-a2dc-b39fee657406) center center`
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PropertyDetails.contextType = EmpresaContext;

const mapStateToProps = state => ({
  imovel: state.profile.currentProfile
});

export default connect(mapStateToProps)(PropertyDetails);

type SliderItemProps = {
  alt: string;
  url: string;
  url_webp?: string;
  logo: string | null;
  ocultar: boolean;
  posicao: string | null;
  use_bg: boolean | undefined | null;
  marca_da_agua: any;
};
function SliderItemWrap(props, { children }) {
  return (
    <div className="item">
      <div
        className="thumb"
        style={{
          height: window.screen.width > 800 ? "90vh" : "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative"
        }}
      >
        {props.children}
      </div>
    </div>
  );
}

function SliderItem(props: SliderItemProps) {
  let img = props.url || "/assets/img/news/19.png";
  let imgWebp = props.url_webp;
  // console.log("posição: ", props.marca_da_agua)
  let logo = props.logo;
  const Watermark = styled.div`
    .watermark {
      color: pink;
      &:after {
        content: "";
        ${props =>
          props.marca_da_agua &&
          css`
          display: block;
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          ${(props.marca_da_agua.ocultar === false ||
            props.marca_da_agua.ocultar === undefined) &&
            `
            background-image: url(${logo});
          `}
          background-size: ${props.marca_da_agua.size || "25%"};
          background-position: ${
            props.marca_da_agua.posicao
              ? props.marca_da_agua.posicao == 0
                ? "center center"
                : props.marca_da_agua.posicao == 1
                  ? "5% 95%"
                  : props.marca_da_agua.posicao == 2
                    ? "95% 95%"
                    : props.marca_da_agua.posicao == 3
                      ? "5% 10%"
                      : props.marca_da_agua.posicao == 4
                        ? "95% 10%"
                        : "center center"
              : "center center"
          };
          background-repeat: no-repeat;
          opacity: ${props.marca_da_agua.opacity || "0.6"};
          z-index: 3334;
      `};
      }
    }
  `;
  return (
    <SliderItemWrap>
      <div
        style={{
          background:
            props.use_bg === false
              ? `#f6f7fb`
              : `url('${isIOS() ? img : imgWebp || img}')`,
          backgroundSize: "cover",
          filter: "blur(4px)",
          height: "100%",
          position: "absolute",
          left: 0,
          top: 0,
          width: "100%"
        }}
      />
      <Watermark marca_da_agua={props.marca_da_agua}>
        <div className="watermark">
          <picture>
            <source srcSet={imgWebp} type="image/webp" />
            <source srcSet={img} type="image/jpg" />
            <img src={img} />
          </picture>
        </div>
      </Watermark>
    </SliderItemWrap>
  );
}
